import {
    CONTENT_ALBUM_ANALYTICS,
    CONTENT_ALBUM_POSTS,
    CONTENT_ALBUMS,
    DASHBOARD,
    DASHBOARD_CUSTOMIZATION,
    DASHBOARD_GENERATE_CUSTOM_REPORT,
    DASHBOARD_VIEW,
    LISTENING_COMPETITOR,
    LISTENING_COMPETITORS,
    LISTENING_FEED,
    LISTENING_FEEDS,
    LISTENING_HASHTAG,
    LISTENING_HASHTAGS,
    REPORTS,
    REPORTS_ACCOUNTS,
    REPORTS_COMPETITORS,
    REPORTS_DASHBOARDS,
    REPORTS_EDIT,
    REPORTS_HASHTAGS
} from '@/lib/routes/privateRoutes';

export const layoutHeaderBackLinks = [
    {
        urls: [
            REPORTS_ACCOUNTS,
            REPORTS_COMPETITORS,
            REPORTS_DASHBOARDS,
            REPORTS_EDIT,
            REPORTS_HASHTAGS
        ],
        redirectUrl: REPORTS,
        text: 'layout_platform:back_links.reports'
    },
    {
        urls: [DASHBOARD_VIEW],
        redirectUrl: DASHBOARD,
        text: 'layout_platform:back_links.dashboard_overview'
    },
    {
        urls: [DASHBOARD_CUSTOMIZATION],
        redirectUrl: DASHBOARD_VIEW,
        text: 'layout_platform:back_links.dashboard',
        keyParam: 'id'
    },
    {
        urls: [DASHBOARD_GENERATE_CUSTOM_REPORT],
        redirectUrl: DASHBOARD_CUSTOMIZATION,
        text: 'layout_platform:back_links.dashboard_customization',
        keyParam: 'id'
    },
    {
        urls: [LISTENING_COMPETITOR],
        redirectUrl: LISTENING_COMPETITORS,
        text: 'layout_platform:back_links.competitors_overview'
    },
    {
        urls: [LISTENING_HASHTAG],
        redirectUrl: LISTENING_HASHTAGS,
        text: 'layout_platform:back_links.hashtags_overview'
    },
    {
        urls: [CONTENT_ALBUM_POSTS, CONTENT_ALBUM_ANALYTICS],
        redirectUrl: CONTENT_ALBUMS,
        text: 'layout_platform:back_links.campaign'
    },
    {
        urls: [LISTENING_FEED],
        redirectUrl: LISTENING_FEEDS,
        text: 'layout_platform:back_links.feeds_overview'
    }
];
